const MAP = {
  Draft: "bg-slate-100 text-slate-600 border-slate-300",
  Ready: "bg-sky-100 text-sky-700 border-sky-300",
  "In Progress": "bg-amber-100 text-amber-800 border-amber-300",
  Completed: "bg-green-100 text-green-700 border-green-300",
  Cancelled: "bg-rose-100 text-rose-700 border-rose-300",
  Pending: "bg-amber-100 text-amber-800 border-amber-300",
  Passed: "bg-green-100 text-green-700 border-green-300",
  Failed: "bg-rose-100 text-rose-700 border-rose-300",
  Hold: "bg-purple-100 text-purple-700 border-purple-300",
  Open: "bg-sky-100 text-sky-700 border-sky-300",
  Created: "bg-sky-100 text-sky-700 border-sky-300",
  Shipped: "bg-green-100 text-green-700 border-green-300",
  "Fully Consumed": "bg-slate-200 text-slate-600 border-slate-300",
  "Partially Shipped": "bg-amber-100 text-amber-800 border-amber-300",
};

export default function StatusBadge({ status, testid }) {
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${MAP[status] || MAP.Draft}`}
    >
      {status}
    </span>
  );
}
